/*
 * Copyright (c) 2026 Ambits Technologies LLC. All rights reserved.
 *
 * This source code is the proprietary and confidential property of
 * Ambits Technologies LLC. Unauthorized copying, modification, distribution,
 * or use of this software, via any medium, is strictly prohibited.
 *
 * MyAmbits - AI-Powered Location Safety & Social Platform
 * https://myambits.com
 */

import type { FakeCallPreset } from "@/types/safecircle";

/**
 * The FakeCallScreen is mounted once in App.tsx; other UI triggers it through
 * a window CustomEvent.
 */
export const FAKE_CALL_EVENT = "safeCircle:fakeCall:trigger";

export interface FakeCallEventDetail {
  preset: FakeCallPreset;
}

export function dispatchFakeCall(preset: FakeCallPreset) {
  const event = new CustomEvent<FakeCallEventDetail>(FAKE_CALL_EVENT, {
    detail: { preset },
  });
  window.dispatchEvent(event);
}
